import { render, staticRenderFns } from "./AdminStudyItemList.vue?vue&type=template&id=6353ef3b&"
import script from "./AdminStudyItemList.vue?vue&type=script&lang=js&"
export * from "./AdminStudyItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports